import { AxiosResponse } from 'axios';
import api from '~/services/api';
import { ClientBillingInterface } from '@e3labs/isa-data-dictionary';
import { UserInterface } from '@e3labs/isa-data-dictionary';
import { FilterFormValues } from '~/store/modules/client-position-report/client-position-report-interface';
import { startOfDay, endOfDay, format } from 'date-fns';

class ClientPositionReportServices {
  getListSuccessClientPositionReports(
    { skip = 0, limit = 10, ...rest },
    opts?: any
  ): Promise<AxiosResponse<ClientBillingInterface[] | null>> {
    return api.get('/client/openbilling', {
      params: {
        skip,
        limit,
        ...rest
      },
      ...opts
    });
  }
  getSuccessRowCount({ skip = 0, limit = 10, ...rest }, opts?: any): Promise<AxiosResponse<any[] | null>> {
    return api.get('/client/openbilling?isCount=true', {
      params: {
        skip,
        limit,
        ...rest
      },
      ...opts
    });
  }
}

export default new ClientPositionReportServices();
